import * as eventTypes from './eventTypes'
import * as actionTypes from './actionTypes'

const eventsMap = {}

eventsMap[actionTypes.AUTHORIZATION_ERROR] = function (action) {
  return {
    type: eventTypes.REQUEST_ERROR,
    args: {
      error: action.payload
    }
  }
}

export default eventsMap
